import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

/**
 * Progress FLUA — barra com onda flowing sobreposta pra dar
 * personalidade em toda métrica de meta/atingimento.
 * Use variant="plain" para desativar a onda em contextos densos.
 */
const Progress = React.forwardRef(({ className, value, variant = "wave", ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative w-full overflow-hidden rounded-full bg-primary/15",
      className || "h-2"
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn(
        "relative h-full w-full flex-1 bg-primary transition-all duration-500",
        variant === "wave" && "flua-progress-wave"
      )}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
